import * as React from 'react';
import * as L from 'leaflet';
import { FeatureGroup } from 'react-leaflet';
import { EditControl } from "react-leaflet-draw"
import type { FeatureCollection, Geometry } from 'geojson';

interface Props {
    geojson: FeatureCollection;
    setGeojson: (geojson: FeatureCollection) => void;
    onCreate: (geo: Geometry) => void;
}


// delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
export default function EditControlFC({ geojson, setGeojson, onCreate }: Props) {
    const ref = React.useRef<L.FeatureGroup>(null);

    React.useEffect(() => {
        console.log('XX: geojson = ', geojson)
        if (ref.current?.getLayers().length === 0 && geojson) {
            L.geoJSON(geojson).eachLayer((layer) => {
                if (
                    layer instanceof L.Polyline ||
                    layer instanceof L.Polygon ||
                    layer instanceof L.Marker
                ) {
                    if (layer?.feature?.properties.radius && ref.current) {
                        new L.Circle(layer.feature.geometry.coordinates.slice().reverse(), {
                            radius: layer.feature?.properties.radius,
                        }).addTo(ref.current);
                    } else {
                        ref.current?.addLayer(layer);
                    }
                }
            });
        }
    }, [geojson]);

    const handleChange = () => {
        const geo = ref.current?.toGeoJSON();
        console.log('XX: geo = ', geo);
        if (geo?.type === 'FeatureCollection') {
            setGeojson(geo);
        }
    };

    const _onCreated = (e: any) => {
        console.log('onCreated', e)
        console.log('onCreated type ', e.type)
        console.log('onCreated', e.layer.toGeoJSON())
        onCreate(e.layer.toGeoJSON());

    }

    return (
        <FeatureGroup ref={ref}>
            <EditControl
                position="topright"
                onEdited={handleChange}
                onCreated={_onCreated}
                onDeleted={handleChange}
                draw={{
                    rectangle: false,
                    circle: true,
                    polyline: true,
                    polygon: true,
                    marker: true,
                    circlemarker: false,
                }}
            />
        </FeatureGroup>
    );
}